/* @flow */
import apiRequest from 'lib/apiRequest';
import { memoize } from 'lodash';
import AuthActions from 'auth/AuthActions';
import { dispatcher } from 'lib/Dispatcher';
import { ActionTypes } from 'user/UserConstants';
import User from 'entities/User';
import GroupActions from 'groups/actions/GroupActions';

/**
 * These accounts are user accounts that were created as part of direct adding
 * users to an organization. They can be claimed, rejected or merged into an
 * existing user account
 */

const loadAccount = (token: string) => apiRequest('/organizations/accounts', 'GET', { token });

const OrganizationAccountActions = {
  loadAccount,
  getOrLoadAccount: memoize(loadAccount),

  claimAccount(token: string, password: string): Promise<void> {
    return apiRequest('/organizations/accounts/claim', 'POST', { token, password })
      .then(user => AuthActions.signIn(user.email, password));
  },

  mergeAccount(token: string): Promise<void> {
    return apiRequest('/organizations/accounts/merge', 'POST', { token }).then(user => {
      GroupActions.loadGroups();
      dispatcher.dispatch({
        type: ActionTypes.USER_UPDATED,
        user: User.fromJSON(user),
      });
    });
  },

  rejectAccount(token: string) {
    return apiRequest('/organizations/accounts/reject', 'POST', { token });
  },
};

export default OrganizationAccountActions;



// WEBPACK FOOTER //
// ./src/actions/OrganizationAccountActions.js